<template lang="pug">
  div.registry.contracts
    e-toolbar(
    :items="items"
    @deleteItems="deleteItems"
    :hideRemoveButton="true"
    :showTotal="true"
    :hideImportBtn="true"
    :showViewPanel="false"
    )
      div(slot="searchResult").parameter.parameter--right
        div.filter-block.tko-operator
          e-suggestion(
          name="_operatorName"
          realName="operator_id"
          :model="filterModel"
          :suggestionEndpoint="suggestionEndpoint"
          :transformSuggestions="transformSuggestions"
          @selectItem="selectItem"
          :suggestDelay="0"
          :minSuggestLen="2"
          :useInnerSearch="false"
          :required="true"
          placeholder="Начните вводить название оператора..."
          )


    e-table(
    :items="items"
    @deleteItem="deleteItem"
    @editItem="editItem"
    :showCheckbox="false"
    )

    router-view

</template>

<script>
  import {tko, contract} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"

  export default {
    mixins: [tableMixin],
    data () {
      return {
        filterModel: {
          operator_id: '',
          _operatorName: ''
        }
      }
    },
    methods: {
      suggestionEndpoint (ctx, q) {
        return tko.operators({query: {q, 'per-page': 50}})
      },
      selectItem ($event) {
        if ($event && $event.id) {
          let copy = JSON.parse(JSON.stringify($event))
          this.filterModel.operator_id = copy.id
          this.filterModel._operatorName = this.$options.filters.stripHtml(
            copy.name
          )
        } else {
          this.filterModel.operator_id = ''
          this.filterModel._operatorName = ''
        }
        this.applyFilter()
      },
      transformSuggestions (ctx, data) {
        return data.data
      },
      getEndpoint (route, fromRoute) {
        return contract.contracts(route)
      },
      getDeleteUrl (id) {
        return contract.contractDelete(id)
      }
    }
  }
</script>
